(function () {
  function initPortfolio(section) {
    var buttons = Array.from(section.querySelectorAll('[data-bb-filter]'));
    var cards = Array.from(section.querySelectorAll('[data-project-type]'));
    var empty = section.querySelector('[data-bb-empty]');
    function apply(filter) {
      var count = 0;
      cards.forEach(function(card) {
        var type = card.getAttribute('data-project-type') || '';
        var show = filter === 'All' || type === filter;
        card.classList.toggle('is-hidden', !show);
        if (show) count++;
      });
      if (empty) empty.hidden = count !== 0;
    }
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        buttons.forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        apply(btn.getAttribute('data-bb-filter') || 'All');
      });
    });
    apply('All');
  }

  function initConsultation(section) {
    var step1 = section.querySelector('[data-step="1"]');
    var step2 = section.querySelector('[data-step="2"]');
    var next = section.querySelector('[data-next-step]');
    var back = section.querySelector('[data-back-step]');
    var typeInput = section.querySelector('[data-input-type]');
    var projectInput = section.querySelector('[data-input-project]');
    var investmentInput = section.querySelector('[data-input-investment]');
    var plansInput = section.querySelector('[data-input-plans]');
    var p1 = section.querySelector('[data-progress-step="1"]');
    var p2 = section.querySelector('[data-progress-step="2"]');
    function go(step) {
      if (!step1 || !step2) return;
      step1.classList.toggle('is-active', step === 1);
      step2.classList.toggle('is-active', step === 2);
      if (p1) { p1.classList.toggle('is-active', step === 1); p1.classList.toggle('is-complete', step === 2); }
      if (p2) p2.classList.toggle('is-active', step === 2);
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    section.querySelectorAll('[data-choice]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.getAttribute('data-choice');
        var value = btn.getAttribute('data-value') || '';
        section.querySelectorAll('[data-choice="'+group+'"]').forEach(function(b){ b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (group === 'type' && typeInput) typeInput.value = value;
        if (group === 'project' && projectInput) { projectInput.value = value; if (next) next.disabled = false; }
        if (group === 'investment' && investmentInput) investmentInput.value = value;
        if (group === 'plans' && plansInput) plansInput.value = value;
      });
    });
    if (next) next.addEventListener('click', function(){ if (projectInput && projectInput.value) go(2); });
    if (back) back.addEventListener('click', function(){ go(1); });
  }

  function initReveal(scope) {
    var els = Array.from(scope.querySelectorAll('.bb-pages-reveal'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function(el){el.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); } });
    }, { threshold: .1, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function(el){ obs.observe(el); });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-bb-portfolio]').forEach(initPortfolio);
    (root || document).querySelectorAll('[data-bb-consultation]').forEach(initConsultation);
    (root || document).querySelectorAll('[data-bb-about]').forEach(initReveal);
  }
  document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
